module.exports = __webpack_public_path__ + "static/media/Help Desk.7c3ba9ae.JPG";